import axios from "axios";

// Create a "Conner" namespace for global methods
var Conner = {};

// Constants
Conner.protocol = window.location.protocol + '//';
Conner.connerCookieName = process.env.REACT_APP_CONNER_COOKIE_NAME;
Conner.userValidatedCookieValue = 'validated';
Conner.validEntriesPerPage = [ "10", "25", "50", "1000"];
Conner.inputLabelPosition = {
  Ani: "ani", 
  Left: "left",
  Right: "right",
  Top: "top", 
  Bot: "bot"
};
Conner.states = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CZ: "Canal Zone",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "DC",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VI: "Virgin Islands",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
}  

// Variables
// All contacts are fetched with a single call and maintained for searching
// in the "contactsData" object.  Within the AddressList component, useState
// handles the filtered search content to render an updated AddressList.
Conner.contactsData = [];
Conner.fieldSearchObj = {}; // Object to hold one or more field search criteria

Conner.buildChildrenList = (children) => {
  let childrenList = '';
  if (children && children.length && children[0] !== null) {
    children.map((child, index, array) => {
      return childrenList = `${childrenList}${child}${(index<array.length-1)?', ':''}`;
    });
  }
  return childrenList;
}

Conner.clearQuickSearch = function() {
  // Get a list of all quick search fields that have filter values
  const activeQuickSearchFilters = document.querySelectorAll('.quicksearchbar .colsearch-container.hasfilter');
  activeQuickSearchFilters.forEach(filter => {
    const clearFieldEle = filter.querySelector('.input-field button');
    const event = new Event('click', { bubbles: true });
    clearFieldEle.dispatchEvent(event);
  })
}

Conner.disableBodyScroll = function() {
  document.body.style.overflow = 'hidden';
}

Conner.enableBodyScroll = function() {
  document.body.style.overflow = 'auto';
}

Conner.exportCsv = async function() {
  let exportContactsUrl = Conner.protocol + process.env.REACT_APP_EXPORT_API;
  //console.log(`Conner.exportCsv: exportContactsUrl = ${exportContactsUrl}`);
  try {
    //const res = await axios.get(exportContactsUrl);
    window.open(exportContactsUrl, "ConnerFamilyCSV");
    return true;
  }
  catch(err) {
    console.error(err);
  }
}

// Conner.fetchAllContacts = async function (p, e, setContacts) {
Conner.fetchAllContacts = async function (initAddressList) {
  let contactsUrl = Conner.protocol + process.env.REACT_APP_CONTACTS_LIST_API;
  // if (arguments.length && parseInt(p) > 0) {
  //   contactsUrl += `?page=${p}`;

  //   if (arguments.length > 1 && Conner.validEntriesPerPage.includes(e)) {
  //     contactsUrl += `&epp=${e}`;
  //   }
  // }

  try {
    const res = await axios.get(contactsUrl);
    Conner.contactsData = res.data;
    initAddressList();
    return;
  }
  catch(err) {
    console.error(err);
  }
}

Conner.fetchContact = async function (id) {
  let contactUrl = Conner.protocol + process.env.REACT_APP_CONTACTS_LIST_API;

  if (arguments && Conner.isNumber(id)) {
    contactUrl += `?id=${id}`;
    
    try {
      const res = await axios.get(contactUrl);
      return res.data[0];
    }
    catch(err) {
      console.error(err);
      return {};
    }
  }
}

Conner.fetchNumAttending = async function (setNumAttending, setShowAttendModal) {
  let numAttendingUrl = Conner.protocol + process.env.REACT_APP_NUMATTENDING_API;

  try {
    const res = await axios.get(numAttendingUrl);
    console.log(res.data[0]);
    setNumAttending(res.data[0]);
    setShowAttendModal(true);
  }
  catch(err) {
    console.error(err);
    return {};
  }
}

Conner.fetchSiblings = async function (setSiblings) {
  let siblingsUrl = Conner.protocol + process.env.REACT_APP_SIBLINGS_API;

  try {
    const res = await axios.get(siblingsUrl);
    setSiblings(res.data);
  }
  catch(err) {
    console.error(err);
    return {};
  }
}

Conner.formatNumber = function(num,frac) {
  const nFormat = new Intl.NumberFormat(undefined, {minimumFractionDigits: frac});
  return nFormat.format(num);
}

Conner.getCookie = function(key) {
  let b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
}

Conner.getParents = function(element, selector) {
  const parents = [];
  let currentElement = element.parentElement;

  while (currentElement) {
    if (!selector || currentElement.matches(selector)) {
      parents.push(currentElement);
    }

    currentElement = currentElement.parentElement;
  }

  return parents;
}

Conner.initValidated = function() {
  let isValidated = (Conner.getCookie(Conner.connerCookieName) === 'validated') ? true : false;
  return isValidated;
}

Conner.isNumber = function(s) {
  return /^-?\d+$/.test(s);
}

Conner.makeid = function(l = 10) {
  for (var e = "", t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", a = 0; a < l; a++) {
      e += t.charAt(Math.floor(Math.random() * t.length))
  }
  return e
}

Conner.makeComplexId = function() {
  return Conner.makeid(5) + '_' + Conner.makeid(5);
}

Conner.keyCode = {
  shift       : 16,
  control     : 17,
  option      : 18,
  alt         : 18,
  command     : 91, 
  escape      : 27,
  spacebar    : 32,
  backspace   : 8, 
  tab         : 9,
  enter       : 13,
  left        : 37,
  right       : 39,
  down        : 40,
  up          : 38,
  home        : 36,
  end         : 35,
  del         : 46,
  pageup      : 33,
  pagedown    : 34
};

Conner.key = {
  shift       : "Shift",
  control     : "Control",
  option      : "Option",
  alt         : "Alt",
  command     : "Command", 
  escape      : "Escape",
  spacebar    : "Space",
  backspace   : "Backspace", 
  tab         : "Tab",
  enter       : "Enter",
  left        : "ArrowLeft",
  right       : "ArrowRight",
  down        : "ArrowDown",
  up          : "ArrowUp",
  home        : "Home",
  end         : "End",
  del         : "Delete",
  pageup      : "PageUp",
  pagedown    : "PageDown"
};

Conner.phoneNumberAutoFormat = function(phoneNumber) {
  if (!phoneNumber || !typeof(phoneNumber) === 'string') {
    return;
  }
  const number = phoneNumber.trim().replace(/[^0-9]/g, "");
  if (number.length < 4) return number;
  if (number.length < 7) return number.replace(/(\d{3})(\d{1})/, "$1-$2");
  if (number.length < 11) return number.replace(/(\d{3})(\d{3})(\d{1})/, "$1-$2-$3");
  return number.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
};

Conner.searchJSON = function(searchkey, searchvalue) {
  if (searchkey === 'active') {
    switch (searchvalue) {
      case true:
        Conner.fieldSearchObj.active = 1;
        break;
      case false:
        delete Conner.fieldSearchObj[searchkey];
        break;
      default:
        break;
    }
  }
  else {
    Conner.fieldSearchObj[searchkey] = searchvalue;
  }
  return Conner.contactsData.filter(item => {
    return Object.keys(Conner.fieldSearchObj).every(fieldSearchKey => {
      switch (typeof item[fieldSearchKey]) {
        case 'string':
          return (typeof item[fieldSearchKey] === 'string' &&
                  item[fieldSearchKey].toLowerCase().includes(Conner.fieldSearchObj[fieldSearchKey].toLowerCase())
                 );
          // break;
        case 'number':
          return (item[fieldSearchKey] === Conner.fieldSearchObj[fieldSearchKey]);
          // break;
        default:
          break;
      }
      return false;
    });
  });
}

Conner.setCookie = function(val, persist) {
  console.log(`Setting cookie - persist = ${persist}`);
  const cookieName = process.env.REACT_APP_CONNER_COOKIE_NAME;
  let expDate = (persist) ? "expires=Fri, 31 Dec 9999 23:59:59 GMT;" : '';
  console.log(`expDate = ${expDate}`);
  document.cookie = `${cookieName}=${val}; path=/; ${expDate}`;
} 

// Initialization

export { Conner }